import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared';
import { MaterialModule } from './shared/material.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { LoaderService } from './core/services';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    CoreModule,
    NgxUiLoaderModule.forRoot(LoaderService.ngxUiLoaderConfig),
    AgmCoreModule.forRoot({
      apiKey: environment.map_key,
      libraries: ['places'],
    }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
